import { APIVersion, axios } from "../../Config/config.js";
const sharedBaseUrl = "https://shared.dev.silal.app";
const generateSignedUrl = `${APIVersion}statics/get_signed_upload_url/`;
// axios.defaults.baseURL = basePath;

const getImages = async (payload) => {
  return await axios.get(
    `${APIVersion}files/library/paginate/?page=${payload.page}&per_page=${payload.limit}`
  );
};

const addImages = async ({ images }) => {
  let failedImages = [];
  let successfulImages = [];

  images?.forEach(async (image, index) => {
    let signedData = await getSignedUrl(image);
    if (signedData.resource) {
      let response = await uploadImageToSignedUrl(signedData?.resource, image);
      if (response.error) {
        failedImages.push(response);
      } else {
        successfulImages.push(response);
      }
    }
  });
  return { failedImages, successfulImages };
};

const getSignedUrl = async (image) => {
  return await axios.post(generateSignedUrl, {
    image_extension: image.image_extension,
    alt: image.alt,
  });
};

const uploadImageToSignedUrl = async (signedData, image) => {
  try {
    await axios.put(signedData.signed_url, { data: image.base64Code });
    await axios.put(
      `${APIVersion}statics/${signedData.id}/finished_uploading/`
    );
    let obj = {
      image_request: image,
      ...signedData,
    };
    return { error: true, data: obj };
  } catch (e) {
    let obj = {
      image_request: image,
      ...signedData,
    };
    return { error: true, data: obj, reason: e };
  }
};
export { getImages, addImages };
